import { Injectable } from '@angular/core';
import { Observable, of, tap } from 'rxjs';
import {  HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { AuthService } from './auth.service';
import { AuthModel } from '../pages/models/auth.models';
import { url } from 'inspector';



@Injectable()
export class TokenInterceptor implements HttpInterceptor {

  authModel: AuthModel | undefined;


  constructor(private authService: AuthService) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    if (!request.url.includes('/CPO/page/Add')) {

    this.authService.checkTokenExpiration();
    const tokenModel = sessionStorage.getItem("tokenModel");
    let obj = null;
    if (tokenModel !== null) 
      obj = JSON.parse(tokenModel);
    

      if (obj !== null) {

        this.authModel = obj;
        if (this.authModel?.Token) {
          request = request.clone({
            setHeaders: {
              Authorization: `Bearer ${this.authModel?.Token}`
            }
          });
        }

        return next.handle(request).pipe(
          tap(
            (event: any) => { },
            err => {
              if (err instanceof HttpErrorResponse && err.status === 401) {
                const refreshToken = this.authModel?.RefreshToken;
                if (!refreshToken) {
                  this.authService.logout();
                }
              }
            }
          )
        );
      }
      else
        return next.handle(request);
    }

    else { return new Observable<HttpEvent<any>>; }
  }
}
